export default __webpack_public_path__ + "static/media/originalLogo.ae2d855e.svg";